import React from "react";
import {
  NumOne,
  TwoOne,
  NumberOne,
  NumberTwo,
  NumberThree,
  NumberFour,
} from "../../common/icons";

import Background from "../../assets/images/explore-background.jpg";
import QbrBackground from "../../assets/images/explore-qantas-background-v3.jpg";

export default function ExploreStep({
  languages,
  stepNo,
  isQBR,
  currentStep,
  isRenewalPage,
}) {
  if (currentStep !== stepNo) {
    return null;
  }
  return (
    <div className="explore">
      <div className="holder-img flex flex-col align-center">
        <img className="" src={isQBR ? QbrBackground : Background} />
        <ul className="holder-text mt-3">
          <li className="list-text flex py-2 xs:items-center">
            <span className="mr-3">
              <NumberOne />
            </span>
            <p className="text font-montserrat font-gray text-xl">
              {languages.exploreMessageListConfirmation
                ? languages.exploreMessageListConfirmation
                : "In a few minutes you will receive a confirmation email of your order."}
            </p>
          </li>
          {!isRenewalPage ? (
            <li className="list-text flex py-2 xs:items-center">
              <span className="mr-3">
                <NumberTwo />
              </span>
              <p className="text font-montserrat font-gray text-xl">
                {languages.exploreMessageListMembership
                  ? languages.exploreMessageListMembership
                  : "Follow the steps in the email to activate your membership."}
              </p>
            </li>
          ) : (
            ""
          )}
          {isQBR ? (
            <>
              <li className="list-text flex py-2 xs:items-center">
                <span className="mr-3">
                  <NumberThree />
                </span>
                <p className="text font-montserrat font-gray text-xl">
                  {languages.exploreQbrPoints
                    ? languages.exploreQbrPoints
                    : "Your Qantas Points will be awarded to your Qantas Business Rewards account within 30 days."}
                </p>
              </li>
              <li className="list-text flex py-2 xs:items-center">
                <span className="mr-3">
                  <NumberFour />
                </span>
                <p className="text font-montserrat font-gray text-xl">
                  {languages.exploreQbrRewards
                    ? languages.exploreQbrRewards
                    : "If you’ve just joined Qantas Business Rewards, be sure to check your email to activate your membership."}
                </p>
              </li>
            </>
          ) : (
            ""
          )}

          <li className="list-text py-2">
            <p className="text font-montserrat font-gray text-xl">
              {languages.exploreCta
                ? languages.exploreCta
                : "Remember to also check your spam inbox. If you don’t receive an email please contact"}{" "}
              <a
                className="text-green text-underline"
                href={
                  languages.exploreCtaLink
                    ? languages.exploreCtaLink
                    : "https://accorplushelp.zendesk.com/hc/en-au"
                }
                target="_blank"
              >
                {languages.exploreCtaLinkTitle
                  ? languages.exploreCtaLinkTitle
                  : "Member Services."}
              </a>
            </p>
          </li>
        </ul>
      </div>
    </div>
  );
}
